let path = "https://api.kestoneglobal.com";
// if (process.env.NODE_ENV === "development") {
//   path = "http://localhost:4010";
// }
export const method = {
  post: "post",
  put: "put",
  get: "get",
  delete: "delete",
};
export const basePath = path;
export const apiPath = basePath + "/api";
export const apiLoginUser = "/auth/login";
export const apiLogutUser = "/auth/logout";
export const apiGetUser = "/auth/profile";
export const apiSentOtp = "/auth/sendOTP"; //not working
export const apiVerifyOTP = "/auth/verifyOTP"; //not working
export const apiReset = "/auth/resetPassword"; //not working
export const apiRegisterUser = "/auth/register";
export const apiCasestudy = "/casestudy";
export const apiUpload = "/files/upload";
export const apiGetAllCasestudy = "/gallery";
export const apiGallery = "/gallery";
